import React from 'react'
import { adminNavItems as dashboardItems } from '../components/sidebar/adminDashboardItems'
import { DashboardBase } from './DashboardBase'

const Dashboard = ({ children }: { children?: React.JSX.Element }) => {
    return <DashboardBase dashboardItems={dashboardItems}>{children}</DashboardBase>
}

export default Dashboard
